// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ChaveMovelButton_reset-list_1MX9z{margin:0;padding:0;list-style:none;display:block}.ChaveMovelButton_uppercase-sm_17eSB{font-size:12px;text-transform:uppercase;letter-spacing:.03667em}.ChaveMovelButton_icon_26-_X{display:block;width:27px;height:auto;margin-right:8px}", ""]);
// Exports
exports.locals = {
	"reset-list": "ChaveMovelButton_reset-list_1MX9z",
	"uppercase-sm": "ChaveMovelButton_uppercase-sm_17eSB",
	"icon": "ChaveMovelButton_icon_26-_X"
};
module.exports = exports;
